import { configureStore } from "@reduxjs/toolkit";
import { reducer as i18nState } from "./localizations";
import { pageTitle } from "./pageTitle";
import { snackbar } from "./snackbar";
import { projectDetails } from "./projectDetails";
import { logs } from "./logs";
import { settingReducer } from "./setting";
import { startsSimulation } from "./startSimulation";
import { projects } from "./projects";

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [snackbar.actions.add.type],
        ignoredPaths: [snackbar.name],
      },
    }),
  reducer: {
    i18nState,
    startsSimulation: startsSimulation.reducer,
    pageTitle: pageTitle.reducer,
    projectDetails: projectDetails.reducer,
    logs: logs.reducer,
    snackbar: snackbar.reducer,
    setting: settingReducer,
    projects: projects.reducer,
  },
});

export type RootStore = ReturnType<typeof store.getState>;
